import { render, staticRenderFns } from "./FormDestinationLocaleBasic.vue?vue&type=template&id=47b51615&scoped=true&"
import script from "./FormDestinationLocaleBasic.vue?vue&type=script&lang=js&"
export * from "./FormDestinationLocaleBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b51615",
  null
  
)

export default component.exports